/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
//import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import AbcIcon from '@mui/icons-material/Abc';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import BusinessIcon from '@mui/icons-material/Business';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import UploadButton from './UploadButton';
import {
  addNewPjAtom,
  allPmsAtom,
  logoListAtom,
  newProjectObjAtom,
  pgmAreasAtom,
  pgTypesAtom,
  selectedLogoAtom,
  blobLogoAtom,
  projectsDataAtom,
  editAtom,
  newEditedPjAtom,
  utilisationsAtom,
} from '../Atoms';
import LocalizedDate from './LocalizedDate';

const useStyles = makeStyles({
  content: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  timePick: {
    marginTop: 15,
    marginBottom: 4,
    padding: 0,
  },
  typeUtil: {
    padding: 0,
    marginTop: 12,
    width: '100%',
  },
});

const NewPj = function NewPj({ add, close, edit = false }) {
  const classes = useStyles();
  const intl = useIntl();
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [name, setName] = useState(null);
  const [client, setClient] = useState(null);
  const [businessName, setBusinessName] = useState(null);
  const [pm, setPm] = useState(null);
  const [kickoff, setKickoff] = useState(new Date());
  const [sop, setSop] = useState(new Date());
  const [type, setType] = useState(null);
  const [area, setArea] = useState(null);
  const [utilisations, setUtilisations] = useState(null);
  const [addNewPj, setAddNewPj] = useRecoilState(addNewPjAtom);
  const setNewProjectObj = useSetRecoilState(newProjectObjAtom);
  const editDialog = useRecoilValue(editAtom);
  const allPms = useRecoilValue(allPmsAtom);
  const pgmAreas = useRecoilValue(pgmAreasAtom);
  const pgTypes = useRecoilValue(pgTypesAtom);
  const logoList = useRecoilValue(logoListAtom);
  const [newEditedPj, setNewEditedPj] = useRecoilState(newEditedPjAtom);
  const [selectedLogo, setSelectedLogo] = useRecoilState(selectedLogoAtom);
  const [blobLogo, setBlobLogo] = useRecoilState(blobLogoAtom);
  const projectsData = useRecoilValue(projectsDataAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);
  const allUtilisations = useRecoilValue(utilisationsAtom);

  useEffect(() => {
    if (typeof add === 'string') setCurrentProjectData(projectsData.find((x) => x.Name === add && x.isCurrent === 1));
    else setCurrentProjectData(null);
  }, [add]);

  const handleSubmit = () => {
    setConfirmClicked(!confirmClicked);
  };

  useEffect(() => {
    if (newEditedPj || addNewPj) close();
  }, [confirmClicked]);
  useEffect(() => {
    if (name && client && pm && type && area && confirmClicked) {
      setNewProjectObj({
        Name: name || 'null',
        Pm: allPms.find((x) => x.PmID === pm).PmName,
        PmID: pm || 'null',
        KickOff: new Date(kickoff) || 'null',
        SopPredicted: new Date(sop) || 'null',
        ProjectType: type,
        Client: client || 'null',
        RagSociale: businessName || '',
        idArea: area - 1,
        UtilisationField: utilisations,
        idVersione: typeof add === 'string' ? currentProjectData.idVersione : 0,
        dataInizioValidita: new Date() || 'null',
        isCurrent: 1,
        ShowSeconds: 15,
        LOGO: selectedLogo,
      });
      if (typeof add === 'string') setNewEditedPj(true);
      else setAddNewPj(true);
      setConfirmClicked(false);
    }
  }, [confirmClicked]);

  useEffect(() => {
    if (typeof add === 'string') setSelectedLogo(currentProjectData ? currentProjectData?.LOGO.logoName : null);
    else {
      setSelectedLogo(null);
      setBlobLogo(null);
    }
    setName(currentProjectData ? currentProjectData.Name : null);
    setClient(currentProjectData ? currentProjectData.Client : null);
    setBusinessName(currentProjectData ? currentProjectData.RagSociale : null);
    setPm(currentProjectData ? currentProjectData.PmID : null);
    setType(currentProjectData ? currentProjectData.ProjectType : null);
    setUtilisations(currentProjectData ? currentProjectData.UtilisationField : null);
    setArea(currentProjectData ? currentProjectData.idArea + 1 : null);
    setKickoff(currentProjectData ? new Date(currentProjectData.KickOff) : new Date());
    setSop(currentProjectData ? new Date(currentProjectData.SopPredicted) : new Date());
  }, [currentProjectData, add]);

  return add ? (
    <Dialog open={add} onClose={close} maxWidth="100vw">
      <DialogTitle style={{ backgroundColor: '#00796b', color: '#fff' }}>
        {editDialog ? edit : intl.messages.NEWPROJECT}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Container className={classes.content}>
          <Container className={classes.col} sx={{ mt: 2 }}>
            {blobLogo ? (
              <img
                alt="logo"
                width="100px"
                height="100px"
                src={`data:${
                  typeof add === 'string' && currentProjectData?.LOGO
                    ? currentProjectData.LOGO.contentType
                    : blobLogo?.contentType
                };base64,${
                  typeof add === 'string' && currentProjectData?.LOGO
                    ? currentProjectData?.LOGO.base64
                    : blobLogo?.base64
                }`}
              />
            ) : (
              <FormControl fullWidth sx={{ mb: 2 }} size="small" error={confirmClicked && !selectedLogo}>
                <InputLabel id="logo" shrink>
                  Logo
                </InputLabel>
                <Select
                  notched
                  labelId="logo"
                  id="logo"
                  label="Logo"
                  value={selectedLogo}
                  onChange={(e) => {
                    if (logoList) setSelectedLogo(e.target.value);
                  }}
                >
                  <MenuItem value={null}>---</MenuItem>
                  {logoList?.map((l) => (
                    <MenuItem value={l}>{l}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {!(typeof add === 'string') && <UploadButton />}
            <TextField
              error={confirmClicked && !name}
              size="small"
              sx={{ width: '100%', mt: 2 }}
              label={intl.messages.PJNAME}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AbcIcon />
                  </InputAdornment>
                ),
              }}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Container>
          <Container className={classes.col} sx={{ mt: 2 }}>
            <TextField
              error={confirmClicked && !client}
              size="small"
              sx={{ width: '100%', mb: 2 }}
              label={intl.messages.CLIENT}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <GroupAddIcon />
                  </InputAdornment>
                ),
              }}
              value={client}
              onChange={(e) => setClient(e.target.value)}
            />
            <TextField
              //error={confirmClicked && !businessName}
              size="small"
              sx={{ width: '100%', mb: 2 }}
              label={intl.messages.BUSINESSNAME}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <BusinessIcon />
                  </InputAdornment>
                ),
              }}
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
            />
            <FormControl fullWidth size="small" error={confirmClicked && !pm}>
              <InputLabel id="pm" shrink>
                {intl.messages.PROJECTMANAGER}
              </InputLabel>
              <Select
                labelId="pm"
                notched
                id="pm"
                label={intl.messages.PROJECTMANAGER}
                value={pm}
                onChange={(e) => setPm(e.target.value)}
              >
                <MenuItem value={null}>---</MenuItem>
                {allPms?.map((item) => (
                  <MenuItem value={item.PmID}>{item.PmName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Container>
          <Container className={classes.col} sx={{ mt: 0 }}>
            <div className={classes.timePick}>
              <FormControl sx={{ width: '49%', mr: '1%' }}>
                <LocalizedDate
                  label={intl.messages.KICKOFF}
                  value={kickoff}
                  onChange={(newDate) => {
                    setKickoff(newDate);
                  }}
                />
              </FormControl>
              <FormControl sx={{ width: '49%', ml: '1%' }}>
                <LocalizedDate
                  label={intl.messages.EXPECTEDSOP}
                  value={sop}
                  onChange={(newDate) => {
                    setSop(newDate);
                  }}
                />
              </FormControl>
            </div>
            <div className={classes.typeUtil}>
              <FormControl fullWidth size="small" sx={{ width: '49%', mr: '1%' }} error={confirmClicked && !type}>
                <InputLabel id="tipo" shrink>
                  {intl.messages.TYPE}
                </InputLabel>
                <Select
                  notched
                  labelId="tipo"
                  id="tipo"
                  label={intl.messages.TYPE}
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value={null}>---</MenuItem>
                  {pgTypes?.map((a) => (
                    <MenuItem value={a.idTipo}>{a.descTipo}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                fullWidth
                size="small"
                sx={{ width: '49%', ml: '1%' }}
                error={confirmClicked && !utilisations}
              >
                <InputLabel id="util" shrink>
                  {intl.messages.UTILISATIONFIELD}
                </InputLabel>
                <Select
                  notched
                  labelId="util"
                  id="util"
                  label={intl.messages.UTILISATIONFIELD}
                  value={utilisations}
                  onChange={(e) => setUtilisations(e.target.value)}
                >
                  <MenuItem value={null}>---</MenuItem>
                  {allUtilisations?.map((u) => (
                    <MenuItem value={u.idUtil}>{u.desUtilisation}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <FormControl fullWidth size="small" sx={{ mt: 2 }} error={confirmClicked && !area}>
              <InputLabel id="pgm" shrink>
                {intl.messages.PROGRAMMANAGER}
              </InputLabel>
              <Select
                notched
                labelId="pgm"
                id="pgm"
                label={intl.messages.PROGRAMMANAGER}
                value={area}
                onChange={(e) => setArea(e.target.value)}
              >
                <MenuItem value={null}>---</MenuItem>
                {pgmAreas?.map((a) => (
                  <MenuItem value={a.idArea + 1}>{a.nomeArea}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Container>
        </Container>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>{intl.messages.DISCARD}</Button>
        <Button
          onClick={() => {
            handleSubmit();
          }}
        >
          {intl.messages.CONFIRMCHANGES}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
};

export default NewPj;
